
const NS = 'IfOnce'; // jshint ignore:line

export default function IfOnce() {
  "ngInject";

  return {
    controllerAs: 'vm',
    restrict: 'A',
    transclude: true,
    template: '<div ng-if="show"><ng-transclude></ng-transclude><div>',
    link,
    scope: {
      ifOnce: '='
    }
  };

  function link($scope) {

    $scope.show = false;
    const cancelShowWatch = $scope.$watch('ifOnce', showChange);

    function showChange() {
      if ($scope.ifOnce) {
        $scope.show = true;
        cancelShowWatch();
      }
    }
  }
}
